import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 32 32"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", { d: "M16 32 0 16 16 0l2.1 2.1L5.7 14.5H32v3H5.7l12.4 12.4z" }, null, -1)
  ]));
}
const ArrowLeft = { render };
export {
  ArrowLeft as default,
  render
};
//# sourceMappingURL=ArrowLeft.svg.js.map
